<template>
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
</template>

<script>
export default {
  name: 'action-delete',
  props:['id'],
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm_delete,
        text: this.$i18n.messages[this.$i18n.locale].delete_message_confirm,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteRecord
        
      })
    },
    deleteRecord () {
      this.$store.dispatch('compliance/delete', this.id)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title:this.$i18n.messages[this.$i18n.locale].deleted,
            text:this.$i18n.messages[this.$i18n.locale].succesfull_delete
          })
          this.$emit('success')
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'Item not found'
          })
        })
    }
  }
}
</script>